export const toTitleCase = (str) => {
  const res = str.replace(
    /^[a-z]|[A-Z]/g,
    (c, i) => (i ? " " : "") + c.toUpperCase()
  );

  return res;
};
